var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarn = function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02667 0H16.9733L24 7.02667V16.9733L16.9733 24H7.02667L0 16.9733V7.02667L7.02667 0ZM15.8667 21.3333L21.3333 15.8667V8.13333L15.8667 2.66667H8.13333L2.66667 8.13333V15.8667L8.13333 21.3333H15.8667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.381 5.95229H10.6191V13.9047H13.381V5.95229Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0475C12.7627 18.0475 13.381 17.4293 13.381 16.6666C13.381 15.9039 12.7627 15.2856 12 15.2856C11.2373 15.2856 10.6191 15.9039 10.6191 16.6666C10.6191 17.4293 11.2373 18.0475 12 18.0475Z",
    fill: "currentColor"
  })));
};

export { SvgWarn as ReactComponent };
export default __webpack_public_path__ + "7cb0b75a5d7f7d28a04dc54a9cebcf03.svg";